import {useNavigate} from 'react-router-dom';
import {useTranslation} from 'react-i18next';
import {useSummary} from 'context/summary';
// import Tabs-deprecated from 'components/common/Tabs-deprecated';
import Page from 'components/Page';
import NavigationPanel from 'components/NavigationPanel';
import BookingStatusPanel from 'components/BookingStatusPanel';
import {
  CustomBackButton,
  //BottomPictureBg,
  //LeftArrowBg,
  // LetsChekinText,
  //PoweredByChekin,
  //RightArrowBg,
  //RightMessageIconBg,
  // WelcomeText,
  //WorldMapBg,
} from './styled';

import arrowLeft from 'assets/icons/arrow-left.svg';
// import bottomPictureBg from 'assets/img/bottom-picture-bg.png';
// import bottomPictureBgTablet from 'assets/img/bottom-picture-bg-tablet.png';
//import leftArrowBg from 'assets/img/left-arrow-bg.png';
//import rightArrowBg from 'assets/img/right-arrow-bg.png';
//import rightMessageIconBg from 'assets/img/right-message-icon-bg.png';
//import worldMapBg from 'assets/img/world-map-bg.png';
//import poweredByChekin from 'assets/img/powered-by-chekin.png';
import {CheckInCompleteModal} from 'components/CheckInCompleteModal/CheckInCompleteModal';
import {usePath, useScreenResize} from 'hooks';
import {device} from '@guestapp/ui/src/utils/device';
import {PATHS} from 'Routes';

function SummaryView() {
  const {t} = useTranslation();
  const {isLoading} = useSummary();
  const {isMatch: isMobile} = useScreenResize(device.tabletSubHeader);
  const navigate = useNavigate();
  const {getFullPath} = usePath();

  //const bottomImg = window.innerWidth < 1025 ? bottomPictureBgTablet : bottomPictureBg;

  return (
    <>
      <Page
        isSubHeaderVisible={isMobile}
        title={t('welcome')}
        isLoading={isLoading}
        navBarTitle={t('online_chekin')}
      >
        <CustomBackButton
          label={t('back')}
          customIcon={<img width={19} height={17} src={arrowLeft} alt="Arrow left" />}
          iconProps={{position: 'left'}}
          onClick={() => navigate(getFullPath(PATHS.home))}
          width="auto"
          link
        />
        {/* <Tabs-deprecated /> */}
        {/* <WelcomeText>{t('welcome')}</WelcomeText>
        <LetsChekinText>{t('lets_check_in')}</LetsChekinText> */}
        <BookingStatusPanel />
        <NavigationPanel />
        <CheckInCompleteModal />
      </Page>
      {/* <WorldMapBg src={worldMapBg} />
      <BottomPictureBg src={bottomImg} />
      <LeftArrowBg src={leftArrowBg} />
      <RightArrowBg src={rightArrowBg} />
      <RightMessageIconBg src={rightMessageIconBg} />
      <PoweredByChekin src={poweredByChekin} /> */}
    </>
  );
}

export {SummaryView};
